import { SinSidebarLayout } from 'layouts/SinSidebarLayout';
import imgWarning from 'assets/images/ilustracion-warning.svg';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';

export const MensajeDatosInsuficientes = () => {
  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <div className="bg-white rounded shadow-md p-4 sm:p-8 relative mb-16 text-center justify-center">
        <img
          src={imgWarning}
          alt="Has aprobado la solicitud correctamente"
          className="mx-auto mb-6 h-40 md:h-80"
        />
        <Heading type="h2">Tenemos un problema</Heading>
        <Text size="M" className="mb-4 max-w-lg mx-auto">
          El enlace al cúal has ingresado ha caducado o es incorrecto. Vuelve a
          intentarlo y verifica que el enlace este completo.
        </Text>
      </div>
    </SinSidebarLayout>
  );
};
